<div
  [class.row-reverse]="position() === 'left'"
  class="card flex flex-col gap-lg p-lg bg-neutral-50 rounded-3xl">
  <div class="card-info md:px-3xl py-lg flex flex-col justify-center">
    @if (badgeLabel()) {
      <mars-badge
        [label]="badgeLabel()"
        badgeClass="mb-3xl px-md py-xs rounded-3xl bg-buyer-500 text-white font-medium" />
    }

    @if (title()) {
      <h3
        class="font-semibold mb-sm md:font-bold md:text-heading-4 rtl:md:text-heading-5 text-large text-primary-500 xl:text-heading-3">
        {{ title() }}
      </h3>
    }

    @if (description()) {
      <p class="md:text-medium text-neutral-700 text-small xl:text-large">
        {{ description() }}
      </p>
    }
  </div>
  <div class="img-container">
    <img class="w-full" [src]="image()" [alt]="title()" />
  </div>
</div>
